export default __webpack_public_path__ + "6e1d0f772c3d8419973617067ae09c58.svg";